module.exports = __webpack_public_path__ + "static/media/bi2.d4ed22fa.png";